<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>
                    
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Ware House"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Department"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="department_id.value.value"
                        :items="getHrmDepartmentList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="department_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Purchase Requisition (as {{ userRole }})
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <!-- <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/purchase/add-requisition')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create Requisition
                      </v-btn>
                    </div> -->
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.approved_ind="{ item }">
                    <v-chip
                      v-if="item.approved_ind == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Yes</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >No</v-chip
                    >
                  </template>

                  <template v-slot:item.status="{ item }">
                      <v-chip
                      :color="statusMap[item.status]?.color || 'grey'"
                      size="small"
                      class="text-capitalize"
                      >
                      {{ statusMap[item.status]?.label || "Unknown" }}
                      </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                      <v-btn
                        icon="mdi-eye"
                        size="small"
                        variant="text"
                        color="primary"
                        @click="viewRequisition(item)"
                      />

                      <v-btn
                        v-if="item.can_edit"
                        icon="mdi-pencil"
                        size="small"
                        variant="text"
                        color="orange"
                        @click="editRequisition(item)"
                      />
                      <v-btn
                        icon="mdi-check"
                        size="small"
                        variant="text"
                        color="green"
                        @click="openApproveDialog(item)"
                      />
                      <v-btn
                        icon="mdi-close"
                        size="small"
                        variant="text"
                        color="red"
                        @click="openRejectDialog(item)"
                      />
                      <v-btn
                        icon="mdi-pause"
                        size="small"
                        variant="text"
                        color="blue"
                        @click="openHoldDialog(item)"
                      />
                  </template>
                </v-data-table>

                <v-dialog v-model="approveDialog" width="400">
                  <v-card>
                    <v-card-title>Approval Remarks</v-card-title>
                    <v-card-text>
                      <v-textarea
                        v-model="remarks"
                        label="Enter remarks (optional)"
                        rows="3"
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey" text @click="approveDialog = false">Cancel</v-btn>
                      <v-btn color="green" @click="submitApproval('approve')">Approve</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="rejectDialog" width="400">
                  <v-card>
                    <v-card-title>Rejection Remarks</v-card-title>
                    <v-card-text>
                      <v-textarea
                        v-model="remarks"
                        label="Enter reason for rejection"
                        rows="3"
                        required
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey" text @click="rejectDialog = false">Cancel</v-btn>
                      <v-btn color="red" @click="submitApproval('reject')">Reject</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="holdDialog" width="400">
                  <v-card>
                    <v-card-title>Hold Remarks</v-card-title>
                    <v-card-text>
                      <v-textarea
                        v-model="remarks"
                        label="Enter reason for hold"
                        rows="3"
                        required
                      />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="grey" text @click="holdDialog = false">Cancel</v-btn>
                      <v-btn color="blue" @click="submitApproval('hold')">Hold</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { shallowRef } from "vue";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";
import axios from "axios";
import { prefix } from '@/store/api';

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    statusMap,
    selectedItem: null,
    headers: [
      {
        title: "#SL",
        align: "center",
        key: "index",
        sortable: false,
      },
      { title: "Code", key: "code", align: "center", sortable: false },
      {
        title: "Department",
        key: "department_name",
      
        align: "left",
        sortable: false,
      },
      {
        title: "Warehouse",
        align: "left",
      
        key: "warehouse_name",
        sortable: true,
      },
      { title: "Request By", align: "left", key: "created_by_name", sortable: true },

      { title: "Apply Date", align: "left", key: "requisition_date", sortable: true },

      { title: "Approval Status", align: "center", key: "approved_ind", sortable: true },

      { title: "Status", align: "center", key: "status", sortable: true },

      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    }
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }
  },
  computed: {
    getSchema () {
      return this.$store.getters.getPendingPurRequisition;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // from_date: yup.date().required().label('Requisition Date'),
        // department_id: yup.number().positive().integer().nullable().label('Department Name'),
        // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),
      }),
    });

    const department_id = useField("department_id");
    const warehouse_id = useField("warehouse_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const userRole = ref("")
    const status = useField("status");
    const approveDialog = ref(false)
    const rejectDialog = ref(false)
    const holdDialog = ref(false)
    const selectedItem = ref(null)
    const remarks = ref("")
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getPendingPurRequisition", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      userRole,
      status,
      approveDialog,
      rejectDialog,
      holdDialog,
      selectedItem,
      remarks,
      errorMessages,
      department_id,
      warehouse_id,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    statusColor(status) {
      // if (status.includes("Pending")) return "orange"
      // if (status.includes("Approved")) return "green"
      // if (status.includes("Rejected")) return "red"
      // if (status.includes("Hold")) return "Blue"
      // return "grey"
    },

    viewRequisition(item) {
      this.$router.push({ name: "requisition-view", params: { id: item.id } })
    },
    editRequisition(item) {
      this.$router.push({ name: "requisition-edit", params: { id: item.id } })
    },
    openApproveDialog(item) {
      this.selectedItem = item
      this.remarks = ""
      this.approveDialog = true
    },
    openRejectDialog(item) {
      this.selectedItem = item
      this.remarks = ""
      this.rejectDialog = true
    },
    openHoldDialog(item) {
      this.selectedItem = item
      this.remarks = ""
      this.holdDialog = true
    },
    async submitApproval(action) {
      if (!this.selectedItem) return
      await axios.post(`${prefix}purchase-requisition/${this.selectedItem.approval_process_id}/${action}`, {
        remarks: this.remarks
      }).then((response) => {
        toast.success(response.data.message, {
          timeout: 3000,
        })
        this.approveDialog = false
        this.rejectDialog = false
        this.holdDialog = false
        this.loadRequisitions()
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
      
    },
    // approveRequisition(item) {
    //   axios.post(`/api/purchase-requisition/${item.approval_process_id}/approve`).then(loadRequisitions)
    // },
    // rejectRequisition(item) {
    //   axios.post(`/api/purchase-requisition/${item.id}/reject`).then(loadRequisitions)
    // },
    editItem(item) {
      // this.$store.commit('setEditingRequisition', item);
      this.$router.push({
        name: "add-requisition",
        query: { id: item.id },
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    loadRequisitions() {
      const values = {
        from_date: formattedDate(this.from_date.value.value),
        to_date: formattedDate(this.to_date.value.value),
        department_id: this.department_id.value.value,
        warehouse_id: this.warehouse_id.value.value,
      };
      this.loading = true;
      this.$store.dispatch("getPendingPurRequisition", values)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          toast.error(error.response.data.message);
        });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Code",
        "Department",
        "Warehouse",
        "Amount",
        "Approval Status",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.department.name,
        item.warehouse.name,
        item.amount,
        item.approved_ind,
        item.status == 1 ? "Active" : "Inactive",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Purchase Requisition List",
        "purchase_requisition_list_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Code",
          "Department",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.department.name,
          item.warehouse.name,
          item.amount,
          item.approved_ind,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToExcel(
        data,
        "purchase_requisition_list_" + this.$fileDate()
      );
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Code",
          "Department",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.department.name,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });

      this.$exportTableToCSV(
        data,
        "purchase_requisition_list_" + this.$fileDate()
      );
    },
  },
  mounted() {
    this.from_date.value.value = new Date();
    this.to_date.value.value = new Date();
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
